var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "product-card",
      attrs: { "data-entity": "item", "data-id": _vm.productId },
    },
    [
      _c(
        "a",
        {
          staticClass: "product-card__body",
          attrs: { href: _vm.detailPageUrl },
        },
        [
          _c(
            "div",
            { staticClass: "product-card__image" },
            [
              _c("v-picture", {
                attrs: { image: _vm.productImg, alt: _vm.productName },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _vm.productCode
            ? _c("div", { staticClass: "product-card__code" }, [
                _vm._v("\n      " + _vm._s(_vm.productCode) + "\n    "),
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("h3", {
            staticClass: "product-card__name",
            domProps: { innerHTML: _vm._s(_vm.productName) },
          }),
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "product-card__actions" }, [
        _c(
          "div",
          {
            staticClass: "product-card__price-block",
            attrs: { "data-entity": "price-block" },
          },
          [
            _c("h3", { staticClass: "product-card__price" }, [
              _c("span", { staticClass: "product-card__price--discount" }, [
                _vm._v(_vm._s(_vm.formattedPriceWithDiscount)),
              ]),
              _vm._v(" "),
              _c("span", { staticClass: "product-card__price--full" }, [
                _vm._v(_vm._s(_vm.formattedPrice)),
              ]),
            ]),
            _vm._v(" "),
            _c("span", { staticClass: "product-card__price-description" }, [
              _vm._v("\n        " + _vm._s(_vm.productMinCount) + "\n      "),
            ]),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "product-card__buttons",
            attrs: { "data-basket-entity": "basket-add-" + _vm.productId },
          },
          [
            _c(
              "div",
              {
                staticClass: "product-card__buttons-item",
                attrs: { "data-entity": "quantity-block" },
              },
              [
                _c(
                  "div",
                  { staticClass: "product-card__buttons-calc calc-product" },
                  [
                    _c("div", {
                      staticClass: "calc-product__action calc-product__less",
                      on: { click: _vm.lessButtonHandler },
                    }),
                    _vm._v(" "),
                    _c("div", { staticClass: "calc-product__field" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.value,
                            expression: "value",
                          },
                        ],
                        attrs: {
                          type: "number",
                          "data-min": _vm.productPackage,
                          "data-max": "100",
                          name: "quantity",
                        },
                        domProps: { value: _vm.value },
                        on: {
                          change: _vm.changeInputHandler,
                          input: function ($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.value = $event.target.value
                          },
                        },
                      }),
                    ]),
                    _vm._v(" "),
                    _c("div", {
                      staticClass: "calc-product__action calc-product__more",
                      on: { click: _vm.moreButtonHandler },
                    }),
                  ]
                ),
              ]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "product-card__buttons-item" }, [
              _c(
                "button",
                {
                  staticClass:
                    "product-card__buttons-buy _btn _btn--transparent",
                  attrs: {
                    "data-goal": "add_cart",
                    "data-ecommerce-name": _vm.productName,
                    "data-ecommerce-id": _vm.productId,
                    "data-ecommerce-price": _vm.priceToRubles,
                    "data-ecommerce-quantity": _vm.value,
                  },
                  on: { click: _vm.buyButtonHandler },
                },
                [_c("p", [_vm._v("Купить")]), _vm._v(" "), _c("span")]
              ),
            ]),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "product-card__buttons",
            attrs: { "data-basket-entity": "basket-link-" + _vm.productId },
          },
          [_vm._m(0)]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "product-card__icons" }, [
          _c(
            "svg",
            {
              staticClass: "product-card__icon compare",
              attrs: {
                width: "19",
                height: "20",
                viewBox: "0 0 19 20",
                xmlns: "http://www.w3.org/2000/svg",
                "data-entity": "compare-checkbox",
                "data-id": _vm.productId,
              },
            },
            [
              _c("path", {
                attrs: {
                  id: "compare-icon",
                  "fill-rule": "evenodd",
                  "clip-rule": "evenodd",
                  d: "M9 18H10V2H9V18ZM8 0C7.44772 0 7 0.447716 7 1V19C7 19.5523 7.44772 20 8 20H11C11.5523 20 12 19.5523 12 19V1C12 0.447715 11.5523 0 11 0H8ZM2 12V18H3V12H2ZM1 10C0.447715 10 0 10.4477 0 11V19C0 19.5523 0.447715 20 1 20H4C4.55228 20 5 19.5523 5 19V11C5 10.4477 4.55228 10 4 10H1ZM16 18V7H17V18H16ZM14 6C14 5.44772 14.4477 5 15 5H18C18.5523 5 19 5.44772 19 6V19C19 19.5523 18.5523 20 18 20H15C14.4477 20 14 19.5523 14 19V6Z",
                },
              }),
            ]
          ),
          _vm._v(" "),
          _c(
            "svg",
            {
              staticClass: "product-card__icon favorite",
              attrs: {
                width: "21",
                height: "21",
                viewBox: "0 0 21 21",
                xmlns: "http://www.w3.org/2000/svg",
                "data-entity": "favorite-checkbox",
                "data-id": _vm.productId,
              },
            },
            [
              _c("path", {
                attrs: {
                  id: "favorite-icon",
                  d: "M10.6779 1.30165L13.4115 7.08318L19.7105 7.62043C20.1474 7.65789 20.0421 7.83698 19.7105 8.12187L15.2156 12.5936L16.6474 18.7074C16.7467 19.1322 16.6917 19.2257 16.3164 19L10.4944 15.9995L4.81641 19C4.4401 19.2248 4.24213 19.1313 4.34142 18.7074L5.77318 12.5936L1.30623 8.12187C0.974606 7.83698 0.839476 7.6569 1.27734 7.61944L7.57628 7.0822L10.2701 1.30165C10.4409 0.899452 10.5071 0.899452 10.6779 1.30165Z",
                },
              }),
            ]
          ),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "a",
      {
        staticClass: "product-card__buttons-buy _btn",
        attrs: { href: "/personal/cart/" },
      },
      [_c("p", [_vm._v("Перейти в корзину")]), _vm._v(" "), _c("span")]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }